/* eslint-disable max-lines */
import * as React from "react";
import { connect } from "react-redux";

import { ThunkDispatch } from "redux-thunk";
import { Form } from "semantic-ui-react";
import { validators } from "not-valid";

import { FormBaseComponent, FormState, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import { CUSTOMER_USER_CASE_TYPES, LinkObject, CurrentUser, isYesNoOptionEnabledOptions } from "@teamprevent/common/model";
import { CaseTypeOrgStructuresEdit } from "@teamprevent/common/customerUser/CaseTypeOrgStructuresEdit";
import { ALL_ORG_STRUCTURES, CustomerUserCaseTypeOrgStructures } from "@teamprevent/common/customerUser/models";
import { toast } from "@teamprevent/common/toasts";
import { OrgStructures } from "@teamprevent/common/orgStructure/components/OrgStructures";
import { OrgStructuresModel } from "@teamprevent/common/orgStructure/models";

import { CustomerUserCreateModel, AppState } from "../model";
import { basePathSelector } from "../selectors";
import { createCustomerUser } from "../actions";
import { Customer, CustomerState, loadCustomers, selectors } from "../../customer";
import { CUSTOMER_ROLES, notCaseManagerRole, notAdministratorRole, notAnySraRole, ADMIN_ROLES } from "../../../auth/model";
import { loadOrgStructures, OrgStructureDetailModel } from "../../orgStructure";
import { orgStructuresSelector } from "../../orgStructure/selectors";
import { isSystemAdmin, Authorize } from "../../../auth/Authorize";
import { CustomerSraDepartment } from "../../customerSraDepartment";
import { ApplicationState } from "../../../applicationState";
import { GenericCaseType } from "../../../genericCaseTypes/models";
import { genericCaseTypesSelector } from "../../../genericCaseTypes/selectors";
import { loadGenericCaseTypes } from "../../../genericCaseTypes/actions";

import { CreateModal } from "./CreateModal";

import "../styles/forms-dividers.scss";
import { GenericCaseTypeEdit } from "./GenericCaseTypeEdit";

import { push } from "redux-little-router";

export interface CreateProps {
    open: boolean;
    customer: Customer;
    customers: Customer[];
    orgStructures: OrgStructureDetailModel[];
    genericCaseTypes: GenericCaseType[];
    currentUser: CurrentUser;
    customerSraDepartments: CustomerSraDepartment[];
    onEmailAddressChanged: (emailAddress: string, valid: boolean) => void;
    loadGenericCaseTypes: () => Promise<void>;
    loadCustomers: () => Promise<void>;
}

export interface DispatchProps extends SaveDispatchProps<CustomerUserCreateModel> {
    close: () => void;
    loadOrgStructures: (customerId: string, parentOrgStructureId: string) => Promise<void>;
}

interface State extends FormState<CustomerUserCreateModel> {
    selectedCustomerId: string | undefined;
}

export class CreateUnconnected extends FormBaseComponent<CustomerUserCreateModel, CreateProps & DispatchProps, State> {
    private genericCaseTypePermissionsEnabled: boolean = false;

    constructor(props: CreateProps & DispatchProps) {
        super(props);
        this.onCaseTypeOrgStructuresChanged = this.onCaseTypeOrgStructuresChanged.bind(this);
        this.handleCaseTypeOrgStructuresChange = this.handleCaseTypeOrgStructuresChange.bind(this);
        props.loadGenericCaseTypes();

        this.state = {
            values: {
                id: "0",
                customerId: props.customer.id,
                emailAddress: "",
                firstName: "",
                surname: "",
                mobileNumber: "",
                roles: [],
                caseTypes: [],
                caseTypeOrgStructures: CUSTOMER_USER_CASE_TYPES.map(ct => { return { value: ct.value, orgStructures: [] as LinkObject[] }; }),
                isMultiFactorAuthenticationEnabled: false,
                sraDepartments: [],
                orgStructureOne: undefined,
                orgStructureTwo: undefined,
                orgStructureThree: undefined,
                orgStructureFour: undefined,
                lockOrgLevelOneForCaseCreation: false,
                genericCaseTypeViewPermissions: [],
                genericCaseTypeViewPermissionsEnabled: false
            },
            valid: {},
            selectedCustomerId: undefined
        };
    }

    public componentDidMount() {
        if (this.props.customers.length <= 1) {
            this.props.loadCustomers();
        }
    }

    public componentDidUpdate() {
        const { handleCaseTypeOrgStructuresChange } = this;
        const { caseTypeOrgStructures } = this.state.values;
        if (caseTypeOrgStructures) {
            CUSTOMER_USER_CASE_TYPES.forEach(ct => {
                handleCaseTypeOrgStructuresChange(ct.value, caseTypeOrgStructures);
            });
        }
    }

    public UNSAFE_componentWillReceiveProps(props: CreateProps & SaveDispatchProps<CustomerUserCreateModel>) {
        this.setState(current => ({ values: { ...current.values, customerId: props.customer.id } }));
    }

    private loadOrgStructure = async (parentOrgStructureId: string) => {
        await this.props.loadOrgStructures(this.props.customer.id, parentOrgStructureId);
    };

    private handleCaseTypeOrgStructuresChange(
        caseTypeVal: string,
        caseTypeOrgStructures: CustomerUserCaseTypeOrgStructures[]) {

        const currCaseStruct = caseTypeOrgStructures.find(ctos => ctos.value === caseTypeVal);
        if (currCaseStruct && currCaseStruct.orgStructures.length > 1) {
            if (currCaseStruct.orgStructures[currCaseStruct.orgStructures.length - 1].id === ALL_ORG_STRUCTURES) {
                this.onCaseTypeOrgStructuresChanged(
                    currCaseStruct,
                    [currCaseStruct.orgStructures[currCaseStruct.orgStructures.length - 1]],
                    currCaseStruct.includeLinkedImmunisationCases);
            } else if (currCaseStruct.orgStructures[0].id === ALL_ORG_STRUCTURES) {
                this.onCaseTypeOrgStructuresChanged(
                    currCaseStruct,
                    currCaseStruct.orgStructures.filter(os => os.id !== ALL_ORG_STRUCTURES),
                    currCaseStruct.includeLinkedImmunisationCases);
            }
        }
    }

    private onCaseTypeOrgStructuresChanged(
        caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures,
        orgStructures: LinkObject[],
        includeLinkedImmunisationCases?: boolean) {

        const currentCaseTypeOrgStructureIndex = this.state.values.caseTypeOrgStructures.findIndex(ct => ct.value === caseTypeOrgStructure.value);
        const newcaseTypeOrgStructures = [...this.state.values.caseTypeOrgStructures];
        newcaseTypeOrgStructures[currentCaseTypeOrgStructureIndex].orgStructures = orgStructures;
        if (includeLinkedImmunisationCases !== undefined)
        {
            newcaseTypeOrgStructures[currentCaseTypeOrgStructureIndex].includeLinkedImmunisationCases = includeLinkedImmunisationCases;
        }
        return this.updateProperty("caseTypeOrgStructures", newcaseTypeOrgStructures, true);
    }

    private onSelectedCustomerChange = (value: string) => {
        this.setState({
            ...this.state,
            selectedCustomerId: value
        });
    };

    private onEmailAddressChanged = (value: string, valid: boolean) => {
        this.setState({
            values: { ...this.state.values, emailAddress: value },
            valid: { ...this.state.valid, emailAddress: valid }
        }, () => this.props.onEmailAddressChanged(value, valid));
    };

    private onOrgStructuresModelChange = (orgStructuresModel: OrgStructuresModel) => {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                orgStructureOne: orgStructuresModel?.orgStructureOne,
                orgStructureTwo: orgStructuresModel?.orgStructureTwo,
                orgStructureThree: orgStructuresModel?.orgStructureThree,
                orgStructureFour: orgStructuresModel?.orgStructureFour
            }
        });
    };

    private onGenericCaseTypeDropDownChanged = (orgStructureIds: LinkObject[]) => {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                genericCaseTypeViewPermissions: orgStructureIds,
                genericCaseTypeViewPermissionsEnabled: orgStructureIds.length > 0
            }
        });
    };

    private onGenericCaseTypePermissionsEnableChanged = (value: boolean) => {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                genericCaseTypeViewPermissionsEnabled: value,
                genericCaseTypeViewPermissions: value ? this.state.values.genericCaseTypeViewPermissions : []
            }
        });
    };

    private customerRoleOptions = () => {
        return Object.keys(CUSTOMER_ROLES) as (keyof typeof CUSTOMER_ROLES)[];
    };

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <h3><label>Customer</label>: {this.props.customer.name}</h3>
                </Form.Field>
                <div className={"fields-divider"} />
                <Input.Dropdown
                    dynamicOptions
                    value={this.state.selectedCustomerId}
                    label="Customer *"
                    placeholder="Customer"
                    options={this.props.customers?.map(c => ({ key: c.id, text: c.name, value: c.id }))}
                    required
                    showErrors={this.state.showErrors}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value) => this.onSelectedCustomerChange(value)}
                />
                <div className={"fields-divider"} />
                <Input.Checkbox
                    label="Lock Org Level 1 for Case Creation"
                    value={this.state.values.lockOrgLevelOneForCaseCreation}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("lockOrgLevelOneForCaseCreation", value, valid)}
                />
                <OrgStructures
                    onOrgStructuresModelChange={this.onOrgStructuresModelChange}
                    submitted={this.state.showErrors}
                    loadOrgStructure={this.loadOrgStructure}
                    customerId={this.props.customer.id}
                />
                <div className={"fields-divider"} />
                <Input.Email
                    value={this.state.values.emailAddress}
                    label="Email Address *"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.onEmailAddressChanged(value, valid)}
                />
                <div className={"fields-divider"} />
                <Input.Text
                    value={this.state.values.firstName}
                    label="First Name *"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("firstName", value, valid)}
                />
                <div className={"fields-divider"} />
                <Input.Text
                    value={this.state.values.surname}
                    label="Surname *"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("surname", value, valid)}
                />
                <div className={"fields-divider"} />
                <Input.Text
                    value={this.state.values.mobileNumber}
                    label="Mobile Number *"
                    showErrors={this.state.showErrors}
                    validation={[validators.validPhoneNumber(10)]}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("mobileNumber", value, valid)}
                />
                <div className={"fields-divider"} />
                <Input.DropdownMulti
                    value={this.state.values.roles}
                    label="Roles *"
                    placeholder="Roles"
                    options={this.customerRoleOptions()
                        .filter(role =>
                            (notCaseManagerRole(role) ||
                                isSystemAdmin(this.props.currentUser)) &&
                            (notAdministratorRole(role) ||
                                isSystemAdmin(this.props.currentUser)) &&
                            (notAnySraRole(role) ||
                                (this.props.customer?.assessmentAndWellBeingFeatures?.indexOf("Stress Risk Assessment") >= 0)))
                        .map(role => ({ key: CUSTOMER_ROLES[role].name, text: CUSTOMER_ROLES[role].displayName, value: CUSTOMER_ROLES[role].name }))}
                    required
                    showErrors={this.state.showErrors}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("roles", value, valid)}
                />
                <div className={"fields-divider"} />
                {isSystemAdmin(this.props.currentUser) &&
                    <Authorize roles={[ADMIN_ROLES.SYSTEM_ADMIN]}>
                        <CaseTypeOrgStructuresEdit
                            caseTypeOrgStructures={this.state.values.caseTypeOrgStructures}
                            orgStructures={this.props.orgStructures}
                            onCaseTypeOrgStructuresChanged={this.onCaseTypeOrgStructuresChanged}
                        />
                        <GenericCaseTypeEdit
                            permissionsEnabled={this.state.values.genericCaseTypeViewPermissionsEnabled}
                            allGenericCaseTypes={this.props.genericCaseTypes}
                            selectedGenericCaseTypes={this.state.values.genericCaseTypeViewPermissions}
                            onGenericCaseTypeChange={this.onGenericCaseTypeDropDownChanged}
                            onPermissionsEnabledChange={this.onGenericCaseTypePermissionsEnableChanged} />
                    </Authorize>
                }
                <div className={"fields-divider"} />
                {this.props.customer.isMultiFactorAuthenticationEnabled && <>
                    <Input.Dropdown
                        value={this.state.values.isMultiFactorAuthenticationEnabled?.toString()}
                        label="Multi Factor Authentication (MFA)"
                        options={isYesNoOptionEnabledOptions.map(c => ({ text: c.text, value: c.value }))}
                        showErrors={this.state.showErrors}
                        onChange={(value, valid) => this.updateProperty("isMultiFactorAuthenticationEnabled", value, valid)}
                    />
                    <div className={"fields-divider"} />
                </>}
                {this.props.customer.assessmentAndWellBeingFeatures?.indexOf("Stress Risk Assessment") >= 0 && <>
                    <Input.DropdownMulti
                        value={this.state.values.sraDepartments}
                        label="SRA Departments"
                        placeholder="SRA Departments"
                        options={this.props.customerSraDepartments.map(department =>
                            ({ key: department.id, value: department.id, text: department.name }))}
                        showErrors={this.state.showErrors}
                        onChange={(value, valid) => this.updateProperty("sraDepartments", value, valid)}
                    />
                </>}
            </Form>
        );
    }

    public submit(): void {
        if (this.state.selectedCustomerId !== this.props.customer?.id) {
            toast.warning("Selected customer does not match the current one!");
            return;
        }
        if (!this.state.values.orgStructureOne?.id) {
            toast.warning("Org Structure Level One must be selected!");
            return;
        }

        if (this.genericCaseTypePermissionsEnabled &&
            this.state.values.genericCaseTypeViewPermissionsEnabled &&
            this.state.values.genericCaseTypeViewPermissions.length === 0)
        {
            toast.warning("Please select relevant option(s) from the Generic Case dropdown!");
            return;
        }

        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

function mapStateToProps(state: AppState & CustomerState & ApplicationState) {
    return {
        customer: selectors.customerSelector(state),
        customers: state.customers,
        orgStructures: orgStructuresSelector(state),
        open: state.router.pathname?.endsWith("/create"),
        basePath: basePathSelector(state),
        currentUser: state.currentUser,
        customerSraDepartments: state.customerSraDepartments,
        genericCaseTypes: genericCaseTypesSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (customerUser: CustomerUserCreateModel, basePath: string) => dispatch(createCustomerUser(customerUser, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath, {})),
        dispatchLoadOrgStructures: (customerId: string, parentOrgStructureId: string) => {
            dispatch(loadOrgStructures({ customerId, parentOrgStructureId }));
        },
        dispatchLoadGenericCaseTypes: () => dispatch(loadGenericCaseTypes()),
        dispatchLoadCustomers: () => dispatch(loadCustomers()),
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): CreateProps & DispatchProps {
    return {
        customer: propsFromState.customer,
        customers: propsFromState.customers,
        orgStructures: propsFromState.orgStructures,
        open: propsFromState.open,
        save: (customerUser: CustomerUserCreateModel) => propsFromDispatch.dispatchSave(customerUser, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(propsFromState.basePath),
        currentUser: propsFromState.currentUser,
        customerSraDepartments: propsFromState.customerSraDepartments,
        onEmailAddressChanged: propsFromState.onEmailAddressChanged,
        loadOrgStructures: propsFromDispatch.dispatchLoadOrgStructures,
        genericCaseTypes: propsFromState.genericCaseTypes,
        loadGenericCaseTypes: propsFromDispatch.dispatchLoadGenericCaseTypes,
        loadCustomers: propsFromDispatch.dispatchLoadCustomers,
    };
}

export const Create = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateModal);
